define([
    "../../hereMapsModule"
], function (hereMapsModule) {
    "use strict";

    hereMapsModule.controller("analysisMapViewHereController", [
        "$scope",
        "$rootScope",
        "hereMapsMarkersFactory",
        "hereMapsService",
        "hereMapsViewportService",
        "nlgMarkerHereMapsService",
        "organizeService",
        "hereMapsRectangleSelectionService",
        "loadingService",
        "messagesModal",
        "carrierZoneGrouperService",
        "hereMapsPolygonDrawingManagerFactory",
        function ($scope,
                  $rootScope,
                  hereMapsMarkersFactory,
                  hereMapsService,
                  hereMapsViewportService,
                  nlgMarkerHereMapsService,
                  organizeService,
                  hereMapsRectangleSelectionService,
                  loadingService,
                  messagesModal,
                  carrierZoneGrouperService,
                  hereMapsPolygonDrawingManagerFactory) {

            $scope.hasTooltipInNearby = true;
            $scope.hasTooltipInNearby = true;

            $scope.routesHereApi = null;
            $scope.markersHereApi = null;
            $scope.polygonsHereApi = null;

            $scope.carrierZonePolygons = null;
            $scope.isDisplayingCarrierZonePolygons = false;

            // Os marcadores selecionados no formato getData()/model para a camada de cima
            $rootScope.selectedHereMapsMarkersModel = $scope.selectedMapMarkers;

            $scope.onRegisterRoutesHereApi = function (api) {
                $scope.routesHereApi = api;

                $scope.onRegisterRoutesApi($scope.routesHereApi);

            };

            $scope.onRegisterPolygonsHereApi = function (api) {
                $scope.polygonsHereApi = api;

                $scope.polygonsHereApi.setSpecifyBundleConfirm(
                    $scope.carrierZoneGrouperToDrawSpecifyBundleConfirm
                );

            };

            $scope.onRegisterMarkersHereApi = function (api) {
                $scope.markersHereApi = api;
                $scope.markersHereApi.setDragendAction(dragendAction);
                $scope.markersHereApi.setClusterTapAction(tapAction);

                $scope.onRegisterMarkersApi({
                    toggleMapMarkers: nlgMarkerHereMapsService.toggleMarkersByModel,
                    selectAllMapMarkers: function () {
                        nlgMarkerHereMapsService.selectAllMapMarkers(getClusterMarkersModel());
                    },
                    cleanMapMarkersSelection: nlgMarkerHereMapsService.cleanSelection,
                    centerOnSelectedMapMarkers: function () {
                        var boundingBox = nlgMarkerHereMapsService.getBoundingBoxOfSelectedMarkers();
                        hereMapsViewportService.centerMapOnBoundingBoxWithPadding(boundingBox, 50);
                    },
                    centerAllMarkers: function () {
                        $scope.markersHereApi.centerMapOnMarkersWithPadding(50);
                    }
                });
            };

            function getClusterMarkersModel() {
                return $scope.here.markersData.clusterMarkersPoints
                    .map(function (clusterMarkersPoint) {
                        return clusterMarkersPoint.data;
                    });
            }

            $scope.here = {
                maps: {
                    hasFullScreen: false,
                    multiplesModes: true,
                    hasDrawCarrierZonePolygonInfo: true,
                    possibleModes: {
                        navigate: true,
                        hasRectSelection: true
                    },
                    possibleButtons: {
                        drawCarrierZonePolygonInfo: drawCarrierZonePolygonInfo
                    },
                    changeCursorOnRoute: true,
                    conditionalHeight: {
                        height: "auto",
                        active: true
                    }
                },
                polygonsData: {
                    polygons: [],
                    onRegisterApi: $scope.onRegisterPolygonsHereApi
                },
                markersData: {
                    clusterMarkersPoints: [],
                    clusterLayerData: {},
                    draggable: true,
                    onRegisterApi: $scope.onRegisterMarkersHereApi
                }
            };

            // CarrierZone
            function drawCarrierZonePolygonInfo() {
                if ($scope.isDisplayingCarrierZonePolygons) {
                    $scope.polygonsHereApi.clearOthersPolygonGroups();
                    $scope.isDisplayingCarrierZonePolygons = false;
                    return;
                }
                if (!$scope.carrierZonePolygons) {
                    loadingService(carrierZoneGrouperService
                        .getPolygonsByGrouperSourceId($scope.carrierZoneGrouperToDraw)
                        .then(function (result) {
                            $scope.carrierZonePolygons = result.carrierZonePolygonDTOs;
                            var multiPolygonGroup = getMultiPolygonGroup();
                            $scope.polygonsHereApi.drawOthersPolygonGroups(multiPolygonGroup);
                        }));
                    $scope.isDisplayingCarrierZonePolygons = true;
                    return;
                }
                var multiPolygonGroup = getMultiPolygonGroup();
                $scope.polygonsHereApi.drawOthersPolygonGroups(multiPolygonGroup);
                $scope.isDisplayingCarrierZonePolygons = true;
            }

            function getMultiPolygonGroup() {
                var polygonGroups = [];
                $scope.carrierZonePolygons.forEach(function (carrierZone) {
                    var colorOfGroup = getRandomRgbaColor();
                    var polygonGroupsData = {
                        mainPolygons: carrierZone.polygon.shells,
                        data: {
                            sourceId: carrierZone.sourceId,
                            name: carrierZone.name,
                            color: colorOfGroup,
                            priority: carrierZone.priority,
                            zIndex: carrierZone.priority,
                            holes: carrierZone.polygon.holes,
                        }
                    };
                    var polygonGroupWithHoles = hereMapsPolygonDrawingManagerFactory.createPolygonGroupWithHoles(
                        polygonGroupsData.mainPolygons,
                        polygonGroupsData.data
                    );
                    polygonGroups.push(polygonGroupWithHoles);
                });
                return polygonGroups;
            }

            function getRandomRgbaColor() {
                var r = Math.floor(Math.random() * 256);
                var g = Math.floor(Math.random() * 256);
                var b = Math.floor(Math.random() * 256);

                return "rgba(" + r + "," + g + "," + b + "," + 0.5 + ")";
            }

            // parte dos markers

            $scope.$watchCollection("markers", setMarkers);

            function setMarkers() {
                if (!$scope.markersHereApi || !hereMapsMarkersFactory) {
                    return;
                }

                $scope.markersHereApi.clearClusterMarkersLayer();

                if (!$scope.markers || $scope.markers.length === 0) {
                    $scope.here.markersData.clusterMarkersPoints = [];
                    return;

                }

                $scope.here.markersData.clusterMarkersPoints = $scope.markers;
                $scope.here.markersData.clusterLayerData = hereMapsMarkersFactory.createClusterMarkersLayer(
                    $scope.here.markersData
                );
                $scope.markersHereApi.setClusterMarkersLayer(
                    $scope.here.markersData.clusterLayerData.layer,
                    $scope.here.markersData.clusterLayerData.provider);

                $scope.markersHereApi.centerMapOnMarkersWithPadding(100);
            }

            function tapAction(markerData) {
                var markers = markerData.markers;
                if (markers.length > 1) {
                    return;
                }
                var event = markerData.event;
                var markerHere = event.target;
                if (event.originalEvent.ctrlKey) {
                    nlgMarkerHereMapsService.toggleMarkers([markerHere]);
                }
            }

            function dragendAction(dragendContext) {
                var marker = dragendContext.marker;
                var noisePoint = marker.getData();
                var targetMarkerData = noisePoint.getData();

                marker.setGeometry(
                    {
                        lat: targetMarkerData.geographicInfo.latitude,
                        lng: targetMarkerData.geographicInfo.longitude
                    }
                );

                var event = dragendContext.event;

                if( !isValidToMove(noisePoint) ) {
                    return messagesModal("dialog.action.not.allowed", [{
                        keyBundle: "order.operationToTrip.thereIsOrderSelected",
                    }]);
                }

                if ($scope.routesHereApi) {
                    var nearbyRoutesMarkers = $scope.routesHereApi.getNearbyRoutesMarker(event);
                    if (nearbyRoutesMarkers && nearbyRoutesMarkers.length > 0) {
                        if (nearbyRoutesMarkers.length === 1) {
                            doManualOperation(nearbyRoutesMarkers[0], targetMarkerData);
                        } else {
                            $scope.routesHereApi.openNearbyRoutesBubble(nearbyRoutesMarkers, event, function (selectedRoute) {
                                doManualOperation(selectedRoute, targetMarkerData);
                            });
                        }
                    }
                }
            }

            function isValidToMove(targetMarker) {
                if ( $scope.selectedMapMarkers.length === 0 ){
                    return true;
                }
                return $scope.selectedMapMarkers.some( function (marker) {
                    return marker.id === targetMarker.getData().id;
                });
            }

            function doManualOperation(targetRoute, targetMarkerData) {
                var route = targetRoute.getData();
                var tripPresentationNode = findRoute(route.tripCode).presentationNode;
                tripPresentationNode.targetClass = "br.com.neolog.model.trip.TripImpl";

                organizeService.organize(
                    formatNodeIdsToDoManualOperation(targetMarkerData),
                    tripPresentationNode
                ).then(function () {
                    if ($scope.refilterBaskets) {
                        $scope.refilterBaskets();
                    }
                });
            }

            function findRoute(tripCode) {
                return $scope.routes.find(function (route) {
                    return route.tripCode === tripCode;
                });
            }

            function formatNodeIdsToDoManualOperation(targetMarkerData) {
                var deliveryUnitNodeIdentifiers = getDeliveryUnitNodeIdentifiers(targetMarkerData);
                return {
                    deliveryUnits: {
                        DeliveryUnit: deliveryUnitNodeIdentifiers,
                        Order: []
                    },
                    tripBasket: {}
                };
            }

            function getDeliveryUnitNodeIdentifiers(targetMarkerData) {
                var deliveryUnitNodeIdentifiers = [];
                if ($scope.selectedMapMarkers.length === 0){
                    targetMarkerData.duId.forEach(function (id) {
                        deliveryUnitNodeIdentifiers.push(createDeliveryUnitNodeIdentifier(id));
                    });
                    return deliveryUnitNodeIdentifiers;
                }
                $scope.selectedMapMarkers.forEach(function (marker) {
                    marker.duId.forEach(function (id) {
                        deliveryUnitNodeIdentifiers.push(createDeliveryUnitNodeIdentifier(id));
                    });
                });
                return deliveryUnitNodeIdentifiers;
            }

            function createDeliveryUnitNodeIdentifier(id) {
                return {
                    id: id,
                    type: {
                        messageKey: "presentationnode.nodetype.delivery.unit",
                        name: "DeliveryUnit"
                    },
                    $parent: {
                        type: {
                            messageKey: "presentationnode.nodetype.routingBasket",
                            name: "ROUTING_BASKET"
                        }
                    }
                };
            }

            $scope.$watch("here.maps.mode", function () {
                if ($scope.here.maps.mode === "rectSelection") {
                    hereMapsRectangleSelectionService.cancelDrawing();

                    hereMapsRectangleSelectionService.startSelection(function (geoRect) {
                        var provider = $scope.here.markersData.clusterLayerData.provider;
                        if (!provider) {
                            return;
                        }

                        var map = hereMapsService.getMap();
                        var rootGroup = provider.getRootGroup();
                        if (!rootGroup || !map) {
                            return;
                        }

                        var pointsInArea = [];
                        var currentZoom = Math.floor(map.getZoom());
                        rootGroup.getObjects().forEach(function(mapObject) {

                            if (mapObject.getVisibility() === true) {
                                var minZoom = typeof mapObject.getMin === "function" ? mapObject.getMin() : 0;
                                var maxZoom = typeof mapObject.getMax === "function" ? mapObject.getMax() : 22;

                                if (currentZoom >= minZoom && currentZoom <= maxZoom) {
                                    var data = mapObject.getData();
                                    var position = data.getPosition();
                                    if (position && geoRect.containsLatLng(position.lat, position.lng) && data) {
                                        if (typeof data.isCluster === "function" && data.isCluster()) {
                                            data.forEachDataPoint(function(dataPoint) {
                                                var clusterData = dataPoint.getData();
                                                if (clusterData) {
                                                    pointsInArea.push({
                                                        data: clusterData
                                                    });
                                                }
                                            });
                                        } else {
                                            var markerData = data.getData();
                                            if (markerData) {
                                                pointsInArea.push({
                                                    data: markerData
                                                });
                                            }
                                        }
                                    }
                                }
                            }
                        });

                        nlgMarkerHereMapsService.toggleMarkersByModel(pointsInArea);
                    });
                }

                if ($scope.here.maps.mode === "navigate") {
                    hereMapsRectangleSelectionService.cancelDrawing();
                }
            });

            $scope.$on("$destroy", function () {
                hereMapsRectangleSelectionService.cancelDrawing();
            });
        }
    ]);
});